import axios from 'axios'
import { apiObject } from './apiobject'

const bulkmail = {
  ...apiObject,
  url: '/notifications/to-client/',
  send (obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${obj.id}/send/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delete (id, ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.url}${id}/`, {ignoreErrorHandle: ignoreErrorHandle})
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
}

const mailsearch = {
  ...apiObject,
  url: '/notifications/messages/',
  read (obj, read = true) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${obj.id}/read/`, {
        read: read
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadCsv ({ search, ordering, filter = {} } = {}) {
    var paramObject = Object.assign({ search, ordering }, filter)
    return axios.get(`${this.url}csv/`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  },
}

export default {
  bulkmail,
  mailsearch
}
